
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tv/[...slug]",
      function () {
        return require("private-next-pages/tv/[...slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tv/[...slug]"])
      });
    }
  